const CoreTemplates = angular.module("CoreTemplates", []).run(["$templateCache", function($templateCache) {}]);
export default CoreTemplates;
/**
  * What is this?
  *   This is an "empty" version of the cache template file.
  *   It is intended to exist to satisfy any 'requires' via git-remote dependencies.
  *   During artifact builds (using the --cachetemplates parameter) this file is recreated containing html template cache values.
  *
  * KNOW:
  * In the 'postinstall' run-script in package.json, this file is being "hidden" from git via:
  *            $>git update-index --assume-unchanged {filename}
  * IF ever needed to be un-done: 
  *            $>git update-index --no-assume-unchanged ${filename}
  * 
  * To view all 'assume unchanged' files run:
  *            $>git ls-files --ignored --exclude-standard
  * @See:  $>git update-index --help
  *
  */